<template lang="jade">
.container-fluid
  header.navbar.navbar-fixed-top.bs-docs-nav(role='banner')
    .homeButton(v-if="$route.name !== 'test' && $route.name !== 'control'")
      i.fa.fa-home.fa-lg(v-on:click='toIndex()')
    // ==============================================================================================//
    // Mobile (.mobile_menu)
    // ==============================================================================================//
    .mobile_menu.hidden-sm.hidden-md.hidden-lg.col-sm-12.col-xs-12.no_pad
      ul.nav.navbar-nav
        li.logo.hidden-xs
          span {{* VV.label.appName }}
          //- a.btn(v-link="{ path: '/' }")
            span cloud
        li.menu__hamburger.pull-left
          a(@click="toShowLeft()")
            i.fa.fa-bars.fa-2

        li.user.pull-right
          dropdown
            button.btn.btn-default(slot='button' data-toggle="dropdown")
              i.fa.fa-user
            ul.dropdown-menu.user_dropdown(slot='dropdown-menu')
              li(v-if="$route.name === 'control'")
                a(v-on:click.prevent="handleShowChgNickname")
                  i.fa.fa-edit
                  |change name
              li
                a(v-on:click.prevent='handleShowChangeProfile')
                  i.fa.fa-user
                  |profile
              li
                a(v-on:click.prevent='showChgPw = true')
                  i.fa.fa-lock
                  |change password
              li
                a(v-on:click.prevent='showAddDevice = true')
                  i.fa.fa-hdd-o
                  |add device
              //- li
              //-   a(v-link="'m2m'")
              //-     img.icon(v-bind="{src:imgs[10]}")
              //-     |M2M
              li
                a(@click="logout()")
                  i.fa.fa-sign-out
                  | Logout
              li(v-if="user.installer && !user.admin")
                a ID: {{ user.installerCode }}
              li
                a {{ version }}
              li.reboot(v-if="$route.name === 'control'")
                a(v-on:click.prevent="reboot") Reboot device
              li.reset(v-if="$route.name === 'control' && (user.installer || user.admin)")
                a(v-on:click.prevent='showPIResetDefaultModal= true') Factory default
        li.machine_name
          dropdown
            button.btn.btn-default(slot='button' data-toggle='dropdown')
              img.icon(
                v-show="!isEmpty(devices)" 
                v-bind="{src:imgs[current.typeId]}")
              span.text(v-if="current.nickname !== null") {{current.nickname || 'Anonymous'}}
            ul.dropdown-menu.machine_dropdown(slot='dropdown-menu')
              li.machine__single(
                v-bind:class.sync="{online: favoriteUiDev.online, current_device: $route.params.mac === favoriteUiDev.mac_address}"
                v-if="favoriteUiDev.isFavor"
              )
                .mask(v-bind:class="{ 'hidden': favoriteUiDev.online}")
                a(v-link="{ name: favoriteUiDev.type, params: { mac: favoriteUiDev.mac_address }}")
                  img.icon(v-bind="{ src: imgs[favoriteUiDev.typeId]}")
                  span.nickName
                    |&nbsp;{{favoriteUiDev.nickname || 'Anonymous'}}
              li.machine__single.dev_ui_list(
                v-for="device in uiDeviceList | orderBy '!online' | filterBy false in 'isFavor' "
                v-bind:class.sync="{online: onlines[device.mac_address], current_device: $route.params.mac === device.mac_address}")
                .mask(v-bind:class="{'hidden': device.online}")
                a(v-link="{ name: device.type , params : { mac: device.mac_address } }")
                  img.icon(v-bind="{src:imgs[device.typeId]}")
                  span.nickName
                    |&nbsp;{{device.nickname || 'Anonymous' }}
              //- //- let favorite device always be in the first of the device list
              //- li.machine__single(
              //-   v-if="mac === user.favorite && (device.ownerId === user.uid && !user.installer && !user.admin || user.installer && device.installerId === user.uid || user.admin)"
              //-   v-for="(mac, device) in devices | orderBy '!online'"
              //-   v-bind:class="{'online':device.online,'current_device': mac === current.mac_address}")
              //-   .mask(v-bind:class="{'hidden': device.online}")
              //-   a(v-link="{ name: device.type , params: { mac:mac } }")
              //-     indicator(v-bind:enable="device.online")
              //-     img.icon(v-show="!isEmpty(devices)" v-bind="{src:imgs[device.typeId]}")
              //-     span.nickName {{ device.nickname || 'Anonymous' }}
              //- //- show all the device if admin
              //- li.machine__single(
              //-   v-if="user.admin"
              //-   v-for="(mac, device) in devices | orderBy '!online'"
              //-   v-bind:class="{'online':device.online,'current_device': mac === current.mac_address}" 
              //-   v-show="mac !== user.favorite")
              //-   .mask(v-bind:class="{'hidden': device.online}")
              //-   a(v-link="{ name: device.type , params: { mac:mac } }")
              //-     indicator(v-bind:enable="device.online")
              //-     img.icon(v-show="!isEmpty(devices)" v-bind="{src:imgs[device.typeId]}")
              //-     span.nickName {{ device.nickname || 'Anonymous' }}
              //- //- show all the installed device if installer
              //- li.machine__single(
              //-   v-if="user.installer"
              //-   v-for="(mac, device) in devices | orderBy '!online' | filterBy user.uid in 'installerId'"
              //-   v-bind:class="{'online':device.online,'current_device': mac === current.mac_address}" 
              //-   v-show="mac !== user.favorite")
              //-   .mask(v-bind:class="{'hidden': device.online}")
              //-   a(v-link="{ name: device.type , params: { mac:mac } }")
              //-     indicator(v-bind:enable="device.online")
              //-     img.icon(v-show="!isEmpty(devices)" v-bind="{src:imgs[device.typeId]}")
              //-     span.nickName {{ device.nickname || 'Anonymous' }}
              //- //- show owned device if user
              //- li.machine__single(
              //-   v-if="!user.installer && !user.admin"
              //-   v-for="(mac, device) in devices | orderBy '!online' | filterBy user.uid in 'ownerId'"
              //-   v-bind:class="{'online':device.online,'current_device':mac === current.mac_address}" 
              //-   v-show="mac !== user.favorite")
              //-   .mask(v-bind:class="{'hidden': device.online}")
              //-   a(v-link="{ name: device.type , params: { mac:mac } }")
              //-     indicator(v-bind:enable="device.online")
              //-     img.icon(v-show="!isEmpty(devices)" v-bind="{src:imgs[device.typeId]}")
              //-     span.nickName {{ device.nickname || 'Anonymous' }}
    // ============================================================================================== //
    // Desktop / PC (.pc_menu)
    // ============================================================================================== //
    .pc_menu.hidden-xs
      ul.nav.navbar-nav.menu__single.left_menu.col-lg-6.col-md-6.col-sm-6
        li.logo
          span {{* VV.label.appName }}
          //- a.btn
            span cloud
        // Desktop (Largest screen size)
        li.menu__hamburger.hidden-sm
          a.btn(@click="toShowLeft()")
            i.fa.fa-bars.fa-2
            |&nbsp;menu
        // iPad
        li.menu__hamburger.col-md-2.no_pad.hidden-lg.hidden-md
          a(@click="toShowLeft()")
            i.fa.fa-bars.fa-2
            |&nbsp;menu
      ul.nav.navbar-nav.col-lg-6.col-md-6.col-sm-6.menu__single.right_menu
        li.user
          dropdown
            button(slot='button').btn.btn-default
              i.fa.fa-user
              |&nbsp; {{ user.name }}
            ul.dropdown-menu.user_dropdown(slot='dropdown-menu')
              // li(v-if="device.typeId === 2")
              li(v-if="user.admin")
                a(v-link="{ name: 'installerList'}")
                  i.fa.fa-list-ul
                  |installer list
              li(v-if="$route.name === 'control'")
                a(v-on:click.prevent="handleShowChgNickname")
                  i.fa.fa-edit
                  |change name
              li
                a(v-on:click.prevent='handleShowChangeProfile')
                  i.fa.fa-user
                  |profile
              li
                a(v-on:click.prevent='showChgPw = true')
                  i.fa.fa-lock
                  |change password
              li
                a(v-on:click.prevent='showAddDevice = true')
                  i.fa.fa-hdd-o
                  |add device
              //- li
              //-   a(v-link="'m2m'")
              //-     img.icon(v-bind="{src:imgs[10]}")
              //-     |M2M
              li
                a(@click="logout()")
                  i.fa.fa-sign-out
                  |logout
              li(v-if="user.installer || user.admin")
                a ID: {{ user.installerCode }}
              li
                a {{ version }}
              li.reboot(v-if="$route.name === 'control'")
                a(v-on:click.prevent="reboot") Reboot device
              li.reset(v-if="$route.name === 'control' && (user.installer || user.admin)")
                a(v-on:click.prevent='showPIResetDefaultModal= true') Factory default
        li.machine_name
          dropdown
            button.btn.btn-default(slot='button' data-toggle='dropdown')
              img.icon(
                v-bind="{src:imgs[current.typeId]}"
                v-show="!isEmpty(dbDevice)")
              span
                i(v-show="isEmpty(dbDevice)").fa.fa-question.icon
                | {{current.nickname}}
            ul.dropdown-menu.machine_dropdown(slot='dropdown-menu' @wheel="wheelOnMachineList")
              li.machine__single
                .arrow_left.arrow
                  a(@click="toScrollSlider('left')")
                    i.fa.fa-angle-left
                .slider_menu.slider_group(v-el:slider)
                  ul
                    li.slider__single.favorite_device(
                      v-bind:class.sync="{online: favoriteUiDev.online, current_device: $route.params.mac === favoriteUiDev.mac_address}"
                      v-if="favoriteUiDev.isFavor"
                    )
                      .mask(v-bind:class="{ 'hidden': favoriteUiDev.online}")
                      a(v-link="{ name: favoriteUiDev.type, params: { mac: favoriteUiDev.mac_address }}")
                        img.icon(v-bind="{ src: imgs[favoriteUiDev.typeId]}")
                        span.nickName
                          |&nbsp;{{favoriteUiDev.nickname || 'Anonymous'}}
                    li.slider__single.dev_ui_list(
                      v-for="device in uiDeviceList | orderBy '!online' | filterBy false in 'isFavor' "
                      v-bind:class.sync="{online: onlines[device.mac_address], current_device: $route.params.mac === device.mac_address}")
                      .mask(v-bind:class="{'hidden': device.online}")
                      a(v-link="{ name: device.type , params : { mac: device.mac_address } }")
                        img.icon(v-bind="{src:imgs[device.typeId]}")
                        span.nickName
                          |&nbsp;{{device.nickname || 'Anonymous' }}
                        //- span {{device['.key'] | json}}
                .arrow_right.arrow
                  a(@click="toScrollSlider('right')")
                    i.fa.fa-angle-right
        //- li.location
          a.btn {{location}}
        //- li.temperature
        //-   a.btn
        //-     span {{temperature}}
        //-     span
        //-       i.wi.wi-celsius

modal.user_profile_edit_modal(
  title="Edit My Profile"
  v-bind:show.sync="showChgProfile"
  effect= "fade"
  cancel-text="Cancel"
  ok-text="Apply"
  v-bind:callback='handleChgProfile'
  backdrop= 'false')
  .modal-body(slot='modal-body').clearfix
    .col-md-12
      label Account
      input.form-control(disabled v-model='user.email')
    .col-md-4
      validator(name="displayName")
        label Display name
        input.form-control(v-model="newName" maxlength='12' v-validate:name="['engAndNum']")
        span.error(v-show='$displayName.name.invalid && $displayName.name.modified')
          |At least 1 English character, number or &apos; allowed
    .col-md-4.no_pad.clearfix
      label.col-xs-12 Auto logout time
      v-select.col-xs-12(
        disabled
        v-bind:value.sync="newSessionTime"
        v-bind:options="sessionOptions"
        v-bind:close-on-select="true")
    .col-md-4.no_pad.clearfix
      label.col-xs-12 Favorite Device
      v-select.col-xs-12(
        v-if="favoriteOptions.length !== 0"
        v-bind:value.sync="favorite"
        v-bind:options.sync="favoriteOptions"
        v-bind:close-on-select="true"
        placeholder="No favorite device"
        v-bind:disabled="favoriteOptions.length === 0")
      span.reminding(v-else) None of your devices online
modal.user_change_pwd(
  v-bind:show.sync="showChgPw"
  title="Edit my password"
  effect= "fade"
  ok-text="Apply"
  cancel-text="Cancel"
  v-bind:callback="handleChgPw"
  backdrop= 'false')
  .modal-body(slot='modal-body').clearfix
    validator(name="changePwValidator")
      .col-md-8
        label old password
        input.form-control(type='password' v-model="oldPwd" maxlength='20' v-bind:readonly="user.installer")
      .col-md-8
        label new password
        input.form-control(type='password' v-model="newPwd" maxlength='20' v-validate:newPwd="['password']" v-bind:readonly="user.installer")
        span.error(v-show='$changePwValidator.newpwd.invalid && $changePwValidator.newpwd.modified')
          |At least 4 English characters or numbers allowed
      .col-md-8
        label confirm password
        input.form-control(type='password' v-model="newPwd2" maxlength='20' v-validate:newPwd2="['password']" v-bind:readonly="user.installer")
        span.error(v-show='$changePwValidator.newpwd2.invalid && $changePwValidator.newpwd2.modified')
          |At least 4 English characters or numbers allowed
modal.add_device(
  v-bind:show.sync="showAddDevice"
  title="Add new device"
  effect="fade"
  ok-text="Apply"
  cancel-tex="Cancel"
  v-bind:callback="handleAddDevice"
  backdrop='false')
  .modal-body(slot='modal-body').clearfix
    validator(name='addDeviceValidation')
      .col-md-8
        label Installer ID (6 digits)
        input.form-control(
          type='number'
          maxlength='6'
          v-model="newDevice.installerCode"
          v-validate:installerCode="['assocCode']" 
          id='installerCode' 
          placeholder="Please enter installelr ID")
        span.error(v-show="$addDeviceValidation.installercode.invalid && $addDeviceValidation.installercode.modified")
          | Invalid installer ID
      .col-md-8
        label Associate Code (6 digits)
        input.form-control(
          type='number' 
          id='assCode' 
          v-model="newDevice.code" 
          v-validate:assCode="['assocCode']" 
          maxlength='6'
          placeholder="Please enter associate code")
        span.error(v-show="$addDeviceValidation.asscode.invalid && $addDeviceValidation.asscode.modified")
          | Six digits needed
modal.pi_chg_name(
  v-bind:show.sync="showChangePiNicknameModal"
  title="Change name"
  effect="fade"
  ok-text="Apply"
  cancel-text="Cancel"
  v-bind:callback="handleChangePiNickName"
  backdrop='false')
  .modal-body(slot='modal-body').clearfix
    .col-xs-12
      label Device Name:
    .col-xs-12.col-md-12
      span
        validator(name='deviceNameValidator')
          input.input.form-control(v-model='newNickname' maxlength='12' v-validate:devicename="['deviceValid']")
        span.error(v-show='$deviceNameValidator.devicename.invalid && $deviceNameValidator.devicename.modified')
          |Only English characters, numbers ,'-' and '_' allowed

modal.pi_reset_default_confirm(
  v-bind:show.sync="showPIResetDefaultModal"
  title="Confirm reset default"
  ok-text="yes"
  cance-text="no"
  backdrop='false'
  v-bind:callback="defaultController")
  .modal-body(slot='modal-body').clearfix
    .col-xs-12
      span Do you really want to reset device 
      span.red {{$route.params.mac}}
      span  to factory default?
    .col-xs-12
      br
      p.red This will erase all the config including username, password or extender relative config and you will need to add this device to cloud again
    



</template>

<script>
  // '
  import $ from 'jquery'
  import VV from '__vendor_variables_js__'
  import select from 'src/components/Single-Select.vue'
  import { aside, dropdown, modal } from 'vue-strap'
  import { logout, changePassword, changeUserProfile, addDevice, deviceTypes,
    getDeviceRef, getOnlineDevsRef, removeFirebaseKey, changeDeviceNickname, getSpecificDevice, factoryDefaultController, rebootController} from 'src/Service'
  import _ from 'lodash'
  import MobileDetect from 'mobile-detect'
  import Indicator from '../components/Indicator.vue'

  export default {
    props: ['showLeftBar'],
    components: {
      dropdown,
      aside,
      modal,
      Indicator,
      vSelect: select
    },
    data: function () {
      return {
        VV: VV,
        // email: '', // for validation
        // numeric: '',
        version: __VERSION__,
        user: {},
        oldPwd: '',
        newPwd: '',
        newPwd2: '',
        newName: '',
        favorite: null,
        favoriteOptions: [],
        favoriteStatus: '',
        uiDeviceList: {},
        favoriteUiDev: {},
        showLeft: false,
        showChgPw: false,
        showChgProfile: false,
        showAddDevice: false,
        showChangePiNicknameModal: false,
        showInstallerList: false,
        showPIResetDefaultModal: false,
        newNickname: 'init',
        // device types:
        //  0       1       2         3         4         5      6       7       8
        // ['', 'power', 'matrix', 'mixer', 'splitter', 'mes', 'dio', 'control', 'ir']
        imgs: [
          '',  // reserve for type 0
          require('assets/img/icon/Power_B.svg'),
          require('assets/img/icon/Matrix_B.svg'),
          require('assets/img/icon/Mixer_B.svg'),
          require('assets/img/icon/Videowall_B.svg'),
          require('assets/img/icon/MES_B.svg'),
          require('assets/img/icon/DIO_B.svg'),
          require('assets/img/icon/Smart_controller_B.svg'),
          require('assets/img/icon/IR_B.svg'),
          require('assets/img/icon/IP_SWITCH_B.svg'),
          require('assets/img/icon/M2M_b.svg')
        ],
        temperature: '58',
        location: 'Taipei',
        mobileTitle: 'Mapping',
        sessionOptions: [
          {
            value: '0',
            label: 'Never'
          },
          {
            value: '24',
            label: 'One day'
          },
          {
            value: '12',
            label: '12 hours'
          },
          {
            value: '1',
            label: 'An hour'
          }
        ],
        newSessionTime: '0',
        newDevice: {
          email: null,
          code: null,
          installerCode: null
        },
        ww: 0,
        wh: 0,
        updateDeviceRef: false
      }
    },
    firebase () {
      return {
        dbOnlines: {
          source: getOnlineDevsRef(),
          asObject: true
        },
        dbDevice: {
          source: getDeviceRef() // filter the device while get the data from firebase
        }
      }
    },
    async asyncData () {
    },
    ready () {
      this.ww = window.innerWidth
      this.wh = window.innerHeight
      window.addEventListener('orientationchange', this.addListener, false)
      window.addEventListener('resize', this.addListener, false)
    },
    computed: {
      onlines () {
        return removeFirebaseKey(this.dbOnlines)
      },
      isMobile () {
        let md = new MobileDetect(window.navigator.userAgent)
        return md.mobile() !== null && this.wh > this.ww && this.$route.isLayout
      },
      current () {
        let { mac } = this.$route.params
        if (this.isEmpty(this.dbDevice)) {
          return {nickname: 'No device', type_id: 0} // to show the string on current.nickname
        } else {
          return this.uiDeviceList[mac]
        }
      }
    },
    methods: {
      reboot () {
        rebootController(this.$route.params.mac)
      },
      defaultController () {
        factoryDefaultController(this.$route.params.mac)
        this.showPIResetDefaultModal = false
      },
      computeUiDevList (devices) {
        this.uiDeviceList = {}
        for (let dev of devices) {
          let mac = dev['.key']
          let uiDev = {
            ...dev,
            online: !!this.onlines[mac],
            type: deviceTypes[dev.typeId],
            mac_address: mac,
            // class: {
            //   online: !!this.onlines[mac],
            //   current_device: mac === this.$route.params.mac
            // },
            isFavor: mac === this.user.favorite
          }
          if (this.user.favorite === mac) {
            this.favoriteUiDev = uiDev
          }
          this.uiDeviceList[mac] = uiDev
        }
        console.log('origin devics', devices)
        console.log('final uiDevList', this.uiDeviceList)
      },
      computeFavoriteOption (devices) {
        this.favoriteOptions = []
        this.favoriteOptions = devices.map(dev => {
          let mac = dev['.key']
          if (!this.user.installer && !this.user.admin) {
          // user
            if (this.user.favorite) {
              if (mac === this.user.favorite && dev.ownerId !== this.user.uid) {
                // favorite is not yours anymore
                return {
                  value: mac,
                  label: 'Not yours any more',
                  online: true,
                  isFake: true
                }
              } else if (dev.ownerId === this.user.uid) {
                console.log('hello1')
                return {
                  value: mac,
                  label: this.onlines[mac] ? (dev.nickname || 'Anonymous') : 'Favorite device offline',
                  online: true,
                  isFake: !this.onlines[mac]
                }
              }
            } else {
              return {
                value: mac,
                label: dev.nickname || 'Anonymous',
                online: this.onlines[mac],
                isFake: false
              }
            }
          } else if (this.user.installer && !this.user.admin) {
            // installer
            if (this.user.favorite) {
              if (mac === this.user.favorite && dev.installerId === this.user.uid) {
                return {
                  value: mac,
                  label: this.onlines[mac] ? (dev.nickname || 'Anonymous') : 'Favorite device offline',
                  online: true,
                  isFake: !this.onlines[mac]
                }
              } else if (mac === this.favorite && dev.installerId !== this.user.uid) {
                return
              }
            }
            return {
              value: mac,
              label: dev.nickname || 'Anonymous',
              online: this.onlines[mac],
              isFake: false
            }
          } else if (this.user.admin) {
            // admin
            if (mac === this.favorite && !this.onlines[mac]) {
              return {
                value: mac,
                label: 'Favorite device offline',
                online: true,
                isFake: true
              }
            }
            return {
              value: mac,
              label: dev.nickname || 'Anonymous',
              online: this.onlines[mac],
              isFake: false
            }
          }
        }).filter(obj => {
          if (obj && obj.online) {
            console.log('obj b4 true', obj)
            return obj.online
          } else {
            return false
          }
        })
      },
      handleShowChangeProfile () {
        this.newName = this.user.name
        this.newSessionTime = String(this.user.session_time)  // must string to prevent select value error
        this.account = this.user.email
        // 如果favorite在線上，把favorite 塞進this.favorite，
        // 如果沒有就不塞，免得在v-select產生髒東西
        this.favorite = null
        for (let dev of this.dbDevice) {
          let mac = dev['.key']
          if (mac === this.user.favorite && this.onlines[mac]) {
            console.log('got favorite')
            this.favorite = this.user.favorite
            break
          }
        }
        console.log('this.favo', this.favorite)
        this.computeFavoriteOption(this.dbDevice)
        this.showChgProfile = true
      },
      handleApplyInstaller () {
        this.showInstallerList = false
      },
      handleShowChgNickname () {
        this.newNickname = this.uiDeviceList[this.$route.params.mac].nickname
        this.showChangePiNicknameModal = true
      },
      handleChangePiNickName () {
        if (!this.newNickname || this.newNickname.trim().length === 0) {
          this.alert('danger', '', 'Please enter at least one English character or number only.')
          return
        }

        if (!this.$deviceNameValidator.devicename.valid && this.newNickname) {
          this.alert('danger', '', 'Invalid device name')
          return
        }

        changeDeviceNickname(this.$route.params.mac, this.newNickname.trim()).then(() => {
          // Vue detect the parent object only ,
          // so "this.device.nickname = this.newNickname" won't trigger the view update
          this.alert('success', '', `Device Name has been set to '${this.newNickname}'.`)
          this.updateDeviceRef = true
        })
        this.showChangePiNicknameModal = false
      },
      addListener () {
        this.ww = window.innerWidth
        this.wh = window.innerHeight
      },
      wheelOnMachineList (e) {
        if (e.deltaX !== 0) {
          return
        }
        if (e.deltaY < 0) {
          this.toScrollSlider('left')
        } else {
          this.toScrollSlider('right')
        }
        e.preventDefault()
      },
      toIndex () {
        this.$router.go({
          name: this.$route.name,
          params: this.$route.params
        })
      },
      alert (type, title, content) {
        this.$dispatch('alert', { type, title, content })
      },
      isEmpty: _.isEmpty,
      logout () {
        logout().then(() => {
          this.alert('success', '', 'Logout Success')
          this.$router.replace('/login')
        })
      },
      toShowLeft () {
        if (this.$route.name === 'control') return
        this.showLeftBar = true
      },
      toScrollSlider (direction) {
        // without animations
        let { slider } = this.$els
        let space = 100
        let curScrollLeft = $(slider).scrollLeft()
        if (direction === 'left' && curScrollLeft > 0) {
          $(slider).scrollLeft(curScrollLeft - space)
        } else if (direction === 'right') {
          $(slider).scrollLeft(curScrollLeft + space)
        }
        // @Todo : add animation
      },
      // ========= for user profile edit ====================
      handleChgProfile () {
        if (this.$displayName.name.valid && this.newName || this.$displayName.name.untouched) {
          changeUserProfile({
            name: this.newName.trim(),
            session_time: this.newSessionTime,
            favorite: this.favorite
          })
          .then(() => {
            this.$dispatch('alert', {
              type: 'success',
              title: '',
              content: 'User profile changed!'
            })
            this.user.name = this.newName.trim()
            this.user.favorite = this.favorite
            this.computeUiDevList(this.dbDevice)
            this.showChgProfile = false
          })
          .catch(err => {
            this.alert('danger', 'Error', err.message)
          })
        } else {
          this.alert('danger', '', 'Please enter a valid name.')
        }
      },
      // ============== for user change password ===========
      async handleChgPw () {
        if (this.$changePwValidator.newpwd.valid && this.$changePwValidator.newpwd2.valid) {
          if (this.newPwd !== this.newPwd2) {
            this.alert('danger', 'Error', 'Please confirm your password again.')
          } else {
            try {
              await changePassword(this.newPwd)
              this.alert('success', '', 'Password Change success.')
              this.showChgPw = false
            } catch (err) {
              console.log(err.message)
              this.alert('danger', '', err.message)
            }
          }
        } else {
          this.alert('danger', '', 'Please enter only English and number as new password only')
        }
      },
      // ================= for add new device =================
      async handleAddDevice () {
        // this.$addDeviceValidation.installer.valid && this.$addDeviceValidation.asscode.valid both are generated by vue-validator
        if (this.newDevice.installerCode.length === 0) return this.alert('danger', '', 'Please enter valid info to add a new device')
        if (this.$addDeviceValidation.asscode.valid && this.$addDeviceValidation.installercode.valid) {
          // console.log(`user uid is ${this.user.uid}`)
          this.newDevice.fbid = this.user.uid
          try {
            await addDevice(this.newDevice)
            this.updateDeviceRef = true
            this.alert('success', '', 'Device successfully added')
            this.alert('warning', '', 'Page will refresh in 10 seconds')
            this.showAddDevice = false
            // if (this.$route.name === 'nodev') {
            setTimeout(() => {
              window.location.replace('/')
            }, 12000)
            // }
          } catch (e) {
            if (typeof e === 'string') {
              this.alert('danger', 'Error', e)
            } else {
              console.error('unexpected error => ', JSON.stringify(e))
              this.alert('danger', 'Error', e.data)
            }
          }
        } else {
          this.alert('danger', '', 'Please enter valid info to add a new device')
        }
      }
    }, // close method()
    watch: {
      updateDeviceRef (nv) {
        if (nv) {
          this.$unbind('dbDevice')
          this.$bindAsArray('dbDevice', getDeviceRef(), null, () => {
            this.computeFavoriteOption(this.dbDevice)
            this.computeUiDevList(this.dbDevice)
            console.log('rebind ready callback')
          })
          this.updateDeviceRef = false
        }
      },
      showChgPw (show) {
        if (show) {
          this.oldPwd = ''
          this.newPwd = ''
          this.newPwd2 = ''
        }
      },
      showAddDevice (show) {
        if (show) {
          this.newDevice.installerCode = ''
          this.newDevice.code = ''
        }
      },
      '$route.name' (name) {
        if (name === 'control') {
          getSpecificDevice(this.$route.params.mac).then(device => {
            this.newNickname = device.nickname
          }).catch(e => {
            this.alert('danger', '', e)
          })
        }
      },
      'user.uid' (nv) {
        this.$unbind('dbDevice')
        this.$bindAsArray('dbDevice', getDeviceRef(), null, () => {
          this.computeFavoriteOption(this.dbDevice)
          this.computeUiDevList(this.dbDevice)
        })
        this.favorite = this.user.favorite || null
      }
    },
    events: {
      user (uid, user) {
        this.user = user
        this.user.uid = uid
      },
      add_device (user) {
        this.showAddDevice = true
      },
      nickname (nickname) {
        this.newNickname = nickname
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~__vendor_variables_scss__";
  @import "~sass/_breakpoint.scss";
  $HH: 40px;
  .navbar {
    background-color: $Header_bg;
    color:$Header_fg;
    height: $HH + 1px;
    min-height: auto;
    @include Header_mixin();
  }
  .nav.navbar-nav > li {
    & > a {
      text-align:center;
      height: $HH;
      line-height: $HH;
      padding-top:0;
      padding-bottom: 0;
      font-size: 16px;
      // line-height:0px;
    }
    .btn-group.open > .btn {
      background-color: $Header_dropdown_btn_hover_bg !important;
      color: $Header_fg !important;
    }
    .btn{
      background-color: $Header_bg;
      color: $Header_fg;
      height:$HH;
      border-radius: 0;
      img {
        filter: $Header_filter_for_dark_img !important;
      }
      &:focus {
        background-color: $Header_dropdown_btn_hover_bg;
        color: $Header_fg;
      }
    }
  }

  // ===== menu
  .menu_group{
    height: 100%;
  }
  // ========== left_menu
  .nav.navbar-nav > li.menu__hamburger{
    & > a{
      font-size: 18px;
      text-align:center;
      cursor:pointer;
      border:none;
      color: $Header_fg;
      background-color: $Header_dropdown_btn_bg;
      @if mixin-exists(Header_btn_mixin) {
        @include Header_btn_mixin ()
      }
      &:hover{
        background-color: $Header_dropdown_btn_hover_bg;
      }
    }
    text-transform:uppercase;
  }
  .logo {
    > span {
      margin-right: 10px;
      display:block;
      height: $HH;
      line-height:$HH;
      font-size: 18px;
      padding-left: 15px;
      @include breakpoint(sm){
        padding-left: 10px;
      }
    }
    > a{
      padding-right: $HH;
      span{
        text-transform:capitalize;
      }
    }
    font-weight: 900;
  }

  // ========== right menu
  .temperature{
    span{
      &:first-child{
        margin-right: 5px;
      }
      display:inline-block;
      vertical-align:middle;
      i{
        font-size: 20px;
      }
    }
  }
  .user,.machine_name{
    .btn{
      outline:0;
      border:none;
      background-color:$Header_dropdown_btn_bg;
      @if mixin-exists(Header_btn_mixin) {
        @include Header_btn_mixin ()
      }
      font-size: 16px;
      &:hover{
        background-color: $Header_dropdown_btn_hover_bg !important;
      }
    }
  }
  .icon{
    height: 18px;
    margin-right: 5px;
    filter: $GLOBAL_filter_for_dark_monotone_img;
  }
  img.icon[src]:not {
    visibility: hidden;
  }
  .machine_dropdown{  // always mobile
    width: 50vw;
    height: 20vh;
    padding-top:0px;
    padding-bottom: 0px;
    .machine__single{
      width:50vw;
      width: 100%;
      height: 20vh;
      font-size: 16px;
      line-height:36px;
      position: relative;
      .arrow {
        z-index: 10;
        font-weight: 900;
        top: 32%;
        width: 40px;
        height: 40px;
        position: absolute;
        cursor:pointer;
        &:hover {
          color: $GLOBAL_fg;
          & a {
            color: $GLOBAL_a_fg_hover;
            font-size: 2em;
            font-weight: 900;
          }
        }
        & a {
          display:block;
          text-align:center;
          color: $GLOBAL_fg;
          width: 40px;
          height: 40px;
          border-radius:50%;
          line-height:35px;
        }
      }
      & .arrow_left{
        left: 15px;
      }
      & .arrow_right{
        right: 15px;
      }
    }
    .favorite_device{
      position: relative;
      &::before {
        font-family: 'FontAwesome';
        content: '\f004';
        display: block;
        position: absolute;
        width:10px;
        height:10px;
        right: $HH;
        top:60px; // top for the desktop
        color: $GLOBAL_heart_fg;
        -webkit-text-stroke: 1px lighten($GLOBAL_heart_fg, 35%)
      }
    }
    .current_device{
      position: relative;
      &::after{
        font-family: 'FontAwesome';
        content:'\f00c';
        display:block;
        -webkit-text-stroke: 1px lighten($Header_dropdown_current_check_fg, 30%);
        width: 10px;
        height: 10px;
        position: absolute;
        right: $HH;
        top: 35px; // top for the desktop
        font-size: 1.3em;
        color: $Header_dropdown_current_check_fg;
      }
    }
  }// close .machine_dropdown

  // ============= global modal styles ===============
  .modal-content {
    label , h2{
      text-transform:capitalize;
    }
    h2 {
      font-size: 20px;
    }
  }
  .modal-header{
    padding:0px 15px;
    & .close{
      margin-top:10px;
    }
  }
  // ============= user profile edit modal ===========
  .user_profile_edit_modal .modal-body > div {
    margin-bottom: 5px;
  }

  .user_dropdown .reset > a:hover {
    background: #f00;
    color: #fff;
    font-weight: 900;
  }




  // ==== .open .machine_dropdown / .user_dropdown ====
  .mobile_menu .open .machine_dropdown {
    max-width:800px;
  }
  .pc_menu .open .machine_dropdown {
    max-width:800px;
    left: auto;
    right: -40px;
  }
  .open{
    .machine_dropdown{
      max-width:800px;
      left: -90px;
    }

    .user_dropdown{
      left: auto;
      right: 0;
      & li > a{
        text-transform:capitalize;
        & .fa{
          margin-right: 5px;
          font-size: 18px;
          width:18px;
          height:18px;
        }
        & .icon{
          width:18px;
          height:18px;
        }
      }

      .reset > a, .reboot > a {
        background: #f00;
        color: #fff;
        font-weight: 900;
      }

      .reboot > a {
        background: #0f0e5e;
      }
    }
  }

  .pc_menu {
      .right_menu.navbar-nav > li{
          /****** If you modify this , you need to reorder the <li> ******/
          float: right;
      }
      .machine_dropdown {  // impossible? machine_dropdown is for mobile only...
          @if mixin-exists(Header_slide_dropdown_mixin) {@include Header_slide_dropdown_mixin ()}
          min-width: 90vw;
          background-color: $Header_dropdown_machine_list_bg__desktop;
          &, .machine__single, .slider_menu, .slider__single {
            min-height: 140px;
          }
      }
  }
  // ==== Mobile menu ====
  .mobile_menu{
    padding: 0;
    > ul > li {  // .machine_dropdown > li
      margin: 0;
      display: inline-block;
    }
    .machine_dropdown{
      background-color: $Header_dropdown_machine_list_item_bg__mobile;
      overflow-x:hidden;
      overflow-y:scroll;
      -webkit-overflow-scrolling: touch;
      width: 180px;
      .machine__single {
        height:48px;
        font-size: 20px;
        & > a {
          padding: 12px 10px !important;
          background-color: $Header_dropdown_machine_list_item_bg__mobile;
          opacity: .8;  // offline
          height: 100%;
        }
        &.online > a{
          opacity: 1;  // online
          position: relative;
        }
        .mask{
          width: 100%;
          height: 100%;
          background-color:transparent;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 5;
        }
      }
    }
    .btn {
      min-width: 50px;
    }

    .open .user_dropdown{
      @include breakpoint(xs){
        background-color: $BS_dropdown_menu_bg;
        border:1px solid $BS_dropdown_menu_border;
        box-shadow:0 6px 12px rgba(0,0,0,.175);
        top: 40px;
      }
    }
  }
  // ==== slider menu ====
  .slider_menu{
    white-space: nowrap;
    overflow-x:scroll;
    padding:0px 40px;
    position: relative;
    left: 0;
    .slider__single {
      position: relative;
      display:inline-block;
      height:20vh;
      padding:20px 0;
      opacity:.2;
      position: relative;

      // to avoid click to the offline device
      .mask{
        width: 100%;
        height: 100%;
        background-color:transparent;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 5;
      }


      @include breakpoint(lg) {
        padding:10px 0px;
      }
      &:last-child{
        & a{
          border-left:none;
        }
      }
      & a{
        width:100%;
        height:100%;
        display:block;
        cursor:pointer;
        text-decoration:none;
        border-right:1px solid $base_gray;
        padding:20px 10px;
        color: $Header_fg;
        position: relative;
        @include breakpoint(lg) {
          padding:0px 10px;
        }
        .icon{
          width: auto;
          height: 60%;
          margin-left: auto;
          margin-right: auto;
          max-width: 85px;
        }
        span{
          text-align:center;

        }
        span .fa{
          text-align:left;
          width:13px;
        }
        & > *{
          display:block;
        }
      }
      &.online{
        opacity:1;
        & a:hover{
          text-decoration:underline;
        }
      }
      .nickName {
        color: $Header_dropdown_machine_list_fg__desktop;
        display: inline-block;
        min-width: 200px;
      }
    }
  }
  // ==== slider menu ====



  // ==== responsive setting ====
  @include breakpoint(sm){
    .mobile_menu .machine_dropdown > .machine__single > a {
      line-height:28px;
      text-align:left;
      padding-left:27px;
    }
    .mobile_menu .logo a.btn{
      padding-top: 5px;
      padding-left: 0px;
    }
  }
  @include breakpoint(xs){
    .nav.navbar-nav > li{
      line-height:25px;
      & > a{
        height:40px;
        line-height:40px;
      }
    }
    .mobile_menu{
      display:block;
      text-align:center;
      & .navbar-nav{
        margin:0;
      }
      > li{
        padding-left: 0px;
        padding-right: 0px;
      }
    }
    .menu__hamburger{
      text-align:left;
      margin-left: 10px;
    }
    li.machine_name{
      .msg{
        margin-left: -50px;
      }
      // text-align:left;
      .btn-group{
        .machine_dropdown{
          width: 280px;
          > li > a {
            line-height:14px;
            text-align:left;
            max-width: 100%;
          }

          .indicator-container {
            float: left;
            margin-right: 8px;
          }
          img {
            float: left;
            margin-right: 8px;
          }
          .nickName {
            float: left;
            width: 190px;
            display: block;
            white-space: nowrap;
            height: 26px;
            // text-overflow: ellipsis;
            overflow: hidden;
          }
          .current_device {
            position: relative;
            &::after{
              color: $Header_dropdown_current_check_fg;
              font-family: 'FontAwesome';
              content:'\f00c';
              position: absolute;
              right: 22px;
              top: 5px;
            }
          }
        }
      }
    }
    li.user{
      text-align:right;
      .btn-group{
        .btn{
          width: 100%;
          font-size: 18px;
        }
      }
    }
    // ==== dropdowns ====
    .open{
      position: relative;
      .dropdown-menu{
        position: absolute;
      }
      .machine_dropdown{
        height: 680px;
        max-height:70vh;
        border:1px solid $Header_dropdown_border;
        box-shadow:0px 1px 5px $GLOBAL_shadow_fg;
        font-size: 14px;
      }
      .machine__single{
        &.online {
          & > a {
            color: $Header_dropdown_machine_list_item_online_fg__mobile;
          }
        }
        & > a {
          color: $Header_dropdown_machine_list_item_offline_fg__mobile;
        }
        &:nth-child(odd) > a{
          background-color: lighten($Header_dropdown_machine_list_item_bg__mobile, 4%);
        }
        background-color:$base_white;
        outline:none;
        height:initial;
      }
    }
  }// end xs

  .fa-heart{
    color: $GLOBAL_heart_fg;
  }
  .homeButton{
    .fa { color: $Header_home_fg; }
    background-color: $Header_home_bg;
    border:1px solid $Header_home_border;
    position:fixed;
    top:46px;
    left: 0px;
    padding:3px;
    font-size: 16px !important;
    // width: 36px;
    // height: 36px;
    border-top-right-radius:7px;
    border-bottom-right-radius:7px;
    border-left: 0px solid transparent;
    @include breakpoint(xs) {
      top: 43px;
      padding: 6px;
    }
    @include breakpoint(xs) {
      top: 43px;
      padding: 6px;
    }
    &:hover {
      .fa { color: $Header_home_hover_fg; }
      background-color: $Header_home_hover_bg;
      border:1px solid $Header_home_hover_border;
      border-left: 0px solid transparent;
    }
  }
  .reminding {
    white-space: nowrap;
    font-size: 12px;
    padding: 0 15px;
    color: #E32222;
  }

  .red {
    background: #f00;
    color: #fff;
    padding-left: 7px;
    padding-right: 7px;
  }

</style>



// WEBPACK FOOTER //
// Header.vue?3683948e